<div
    class="agpr-paginator"
    [ngClass]="{'agpr-paginator--disabled': isDisabled}"
>
    <div class="agpr-paginatorNavigationButtons">
        <button
            class="agpr-paginatorNavigationButtons-button left"
            [id]="id + '.paginator.navigationButtonLeft'"
            (click)="pageBackClick()"
            [disabled]="backButtonDisabled || isDisabled"
            [attr.aria-label]="'Paginator.previous' | localize"
        >
            <span class="fa-solid fa-angle-left"></span>
        </button>
        <input
            pInputText
            #pageInput
            class="agpr-paginatorNavigationButtons-input"
            [id]="id + '.paginator.pageInput'"
            type="number"
            min="1"
            [max]="totalNumberOfPages"
            [ngModel]="pageNumber"
            (blur)="onInput($event)"
            (keyup)="onKeyUp($event)"
            [disabled]="isDisabled"
            [attr.aria-labelledby]="id + '_paginator_pageInputLabel'"
        />
        <span class="sr-only" [id]="id + '_paginator_pageInputLabel'">
            {{ 'Paginator.pageNumberOfTotalPages' | localize: {totalPage: totalNumberOfPages} }}
        </span>
        <span>
            {{ 'Paginator.of' | localize }}
        </span>
        <span
            class="agpr-paginatorNavigationButtons-pageCount"
        >
            {{ totalNumberOfPages | number }}
        </span>
        <button
            class="agpr-paginatorNavigationButtons-button right"
            [id]="id + '.paginator.navigationButtonRight'"
            (click)="pageForwardClick()"
            [disabled]="forwardButtonDisabled || isDisabled"
            [attr.aria-label]="'Paginator.next' | localize"
        >
            <span class="fa-solid fa-angle-right"></span>
        </button>
    </div>
</div>

